<template>
    <div class="headers">
        <div class="headers-top">
            <div class="headers-top-left">
                <img :src="company.companyLogo" alt/>
            </div>
            <div class="headers-top-right">
                <ul>
                    <li v-for="(item,index) in  list" :key="index" @click="menuClick(item,index)"
                        :class="{activeMenu:currentActive==index}">{{langes==0?item.barName:item.barEngName}}
                    </li>
                </ul>
                <!-- <el-select v-model="selectLanguage" @change="selectLanguageChange">
                    <el-option value="CN" label="中文" key="CN"></el-option>
                    <el-option value="ENG" label="ENGLISH" key="ENG"></el-option>
                </el-select> -->
            </div>
        </div>
       <div class="images">
            <el-carousel trigger="click" height="500px">
                <el-carousel-item v-for="(item, index) in advertList" :key="index">
                    <a :href="item.advertPath" target="view_window">
                        <img :src="item.advertImgPath" />
                    </a>
                </el-carousel-item>
            </el-carousel>
        </div> 
    </div>
</template>
<script>
    /* eslint-disable */
    export default {
        name: 'headers',
        props:{
            activeIndex:{
                type: Number,
                default:0
            }
        },
        data() {
            return {
                currentSpan: 0,
                company: {},
                imgUrl: this.$api.imageUrl,
                list: [],
                currentActive: 0,
                langes: 0,
                menuObj: {},
                currentPath: '',
                advertList: [],
                selectLanguage:"CN"
            }
        },
        inject: ['parentEle'],
        mounted() {
            this.getCompany();
            this.getTopMenu();
            this.getImg();
            this.resetSetItem('watchStorage', 0);
            window.addEventListener('setItem', () => {
                this.langes = sessionStorage.getItem('watchStorage');
            })
        },
        watch:{
           activeIndex(){
               //发生变化
               currentActive:3
           }

        },
        methods: {
            // 菜单点击
            menuClick(item, index) {
                this.parentEle.menuObj = item;
                this.parentEle.urls = item.barUrl;
                this.parentEle.title = item.barEngName;
                this.currentActive = index;
                this.currentPath = item.barUrl;
                sessionStorage.setItem('currentPath', item.barUrl);
                let pathList = [];
                pathList.push(item);
                sessionStorage.setItem('pathList', JSON.stringify(pathList));
                this.parentEle.barType = item.barType;
            },
            selectLanguageChange(value){
                if(value == "ENG"){
                    this.resetSetItem('watchStorage', 1);    
                }else{
                    this.resetSetItem('watchStorage', 0);
                }

            },
            //外部进来的点击之后可到某个值处
            menuClickList(index){
                var item = this.list[index];
                this.parentEle.menuObj = item;
                this.parentEle.urls = item.barUrl;
                this.parentEle.title = item.barEngName;
                this.currentActive = index;
                this.currentPath = item.barUrl;
                sessionStorage.setItem('currentPath', item.barUrl);
                let pathList = [];
                pathList.push(item);
                sessionStorage.setItem('pathList', JSON.stringify(pathList));
                this.parentEle.barType = item.barType;        
            },
            langeClick(val) {
                this.currentSpan = val === 'chinese' ? 0 : 1;
                // 0 代表中文  1  代表英文
                this.resetSetItem('watchStorage', this.currentSpan);
            },
            //获取公司信息
            getCompany() {
                this.$api.get('/api/web/company_info').then(res => {
                    this.company = res.response;
                    this.company.companyLogo = this.imgUrl+this.company.companyLogo
                })
            },
            //获取前端顶部菜单
            getTopMenu() {
                this.$api.get('/api/web/navigation_info').then(res => {
                    this.list = res.response.filter(i => i.barEnable === 1);
                    let _index = sessionStorage.getItem('currentPath') ? this.list.findIndex(i => i.barUrl === sessionStorage.getItem('currentPath')) : 0;
                    this.menuClick(this.list[_index])
                    this.currentActive = _index;
                })
            },
           // 获取广告图
            getImg() {
                this.$api.get('/api/web/home_advert').then(res => {
                    this.advertList = res.response
                    if(this.advertList.length != 0){
                        this.advertList.forEach(e =>{
                            e.advertImgPath = this.imgUrl+e.advertImgPath
                        })
                    }

                })
                console.log("该网站由《深圳市青九风网络科技有限公司》研发,代码所有权归青九风公司所有.")
            }
        }
    }
</script>
<style scoped lang="less">
    .headers {
        width: 100%;
        text-align: center;
        margin: 0 auto 20px;
        padding-top: 20px;
        .images {
            margin-top: 20px;
            width: 100%;
            /deep/ .el-carousel__item {
                img {
                    height: 500px;
                    width: 100%;
                }
            }
        }
        &-top {
            height: 60px;

            &-left {
                display: inline-block;
                margin-right: 20px;
                img {
                    height: 60px;
                }
            }

            &-right {
                display: inline-block;
                height: 60px;
                line-height: 60px;

                ul {
                    display: flex;
                    justify-content: flex-start;
                    margin-right: 10px;
                    float: left;

                    li {
                        font-size: 14px;
                        margin-right: 20px;
                        color: #333;
                        cursor: pointer;
                    }

                    li:hover {
                        color: #2950b8;
                    }

                    .activeMenu {
                        color: #2950b8;
                    }
                }

                /deep/ .el-input {
                    float: left;
                    width: 110px;
                }
            }
        }
    }
</style>